/* eslint-disable */
import React from 'react'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {Icon} from 'antd'
class MyDatePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: this.props.setDefaultValue ? moment() : null,
      selectedDateTo: this.props.setDefaultValue ? moment() : null
    }
    if (this.props.setDefaultValue) {
      let myFromData = this.epochFrom(this.convertDigit(jMoment(this.state.selectedDateFrom).format('jYYYY/jMM/jDD')))
      let myToData = this.epochTo(this.convertDigit(jMoment(this.state.selectedDateFrom).format('jYYYY/jMM/jDD')))
      this.props.onChangeFromDate(myFromData)
      this.props.onChangeToDate(myToData)
    } else {
      this.props.onChangeFromDate(null)
      this.props.onChangeToDate(null)
    }
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleDateChangeFrom = (date) => {
    let myDate = this.epochFrom(this.convertDigit(jMoment(date).format('jYYYY/jMM/jDD')))
    this.props.onChangeFromDate(myDate)
    this.setState({
      selectedDateFrom: date
    })
    if (this.props.limitToDate) {
      this.setState({
        selectedDateTo: date
      })

      let myDate = this.epochTo(this.convertDigit(jMoment(date).format('jYYYY/jMM/jDD')))
      this.props.onChangeToDate(myDate)
    }
  }
  handleDateChangeTo = (date) => {
    let myDate = this.epochTo(this.convertDigit(jMoment(date).format('jYYYY/jMM/jDD')))
    this.props.onChangeToDate(myDate)
    this.setState({
      selectedDateTo: date
    })
  }

  deleteFromDate = () => {
    this.setState({
      selectedDateFrom: null
    })
    this.props.onChangeFromDate(null)
  }

  deleteToDate = () => {
    this.setState({
      selectedDateTo: null
    })
    this.props.onChangeToDate(null)
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  toDate(props) {
    return <input className="form-control" {...props} />
  }

  render() {
    let {selectedDateFrom, selectedDateTo} = this.state
    return (
      <div className="datepickerComponentWrapp">
        <div className="formComponent">
          <label>{this.props.fromLabel}</label>
          <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
            <DatePicker
              okLabel="تأیید"
              cancelLabel="لغو"
              autoOk={true}
              leftArrowIcon={<Icon type="left" />}
              rightArrowIcon={<Icon type="right" />}
              labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
              onChange={this.handleDateChangeFrom}
              TextFieldComponent={this.fromDate}
              id={this.props.fromId}
              value={selectedDateFrom}
              readOnly
            />
          </MuiPickersUtilsProvider>
          {/*<span className='deleteDate' onClick={()=>this.deleteFromDate()}>*/}
          {/*<img src={require('../../image/eraser.svg')}/>*/}
          {/*</span>*/}
        </div>
        <div className="formComponent">
          <label>{this.props.toLabel}</label>
          <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
            <DatePicker
              okLabel="تأیید"
              cancelLabel="لغو"
              autoOk={true}
              leftArrowIcon={<Icon type="left" />}
              rightArrowIcon={<Icon type="right" />}
              labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
              onChange={this.handleDateChangeTo}
              TextFieldComponent={this.toDate}
              id={this.props.toId}
              minDate={this.props.limitToDate ? selectedDateFrom : 0}
              value={selectedDateTo}
              readOnly
            />
          </MuiPickersUtilsProvider>
          {/*<span className='deleteDate' onClick={()=>this.deleteToDate()}>*/}
          {/*<img src={require('../../image/eraser.svg')}/>*/}
          {/*</span>*/}
        </div>
      </div>
    )
  }
}
export default MyDatePicker
